<mat-card>{{'products' | translate}}</mat-card>


<div align="end" class="row" style="padding:10px;">
  <span class="spacer"></span>
  <button mat-raised-button color="primary" (click)="createNew()">
    <mat-icon>add</mat-icon>
    {{'create' | translate}}
  </button>
</div>

<div class="container" style="padding: 25px;">

  <mat-grid-list cols="8" rowHeight="50px">



    <mat-grid-tile colspan="2">
      <form class="example-form">
        <mat-form-field appearance="standard" class="example-full-width">
          <mat-label>{{'selectCategory' | translate}}</mat-label>
          <input type="text" matInput [formControl]="searchCategory" required [matAutocomplete]="auto">
          <button mat-button matSuffix mat-icon-button>
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectCatChange($event.option.value)"
            [displayWith]="displayFnCategory">
            <mat-option *ngFor="let option of filteredOptionsCategory | async" [value]="option">
              <img class="example-option-img" aria-hidden [src]="imagPath + option.imageUrl" height="25" width="25"
                style="object-fit: fill;">
              <span>&nbsp;</span>
              <span>{{language == 1 ? option.arabicName : option.englishName}}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form>
    </mat-grid-tile>
    &nbsp;
    <mat-grid-tile colspan="1">
      <mat-form-field appearance="standard" style="margin-right: 5px;">
        <mat-label>{{'directCharged' | translate}}</mat-label>
        <mat-select [(value)]="directCharge" (selectionChange)="getsubCategory()">
          <mat-option [value]="true"> {{'yes' | translate}} </mat-option>
          <mat-option [value]="false"> {{'no' | translate}} </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>
    &nbsp;

    <mat-grid-tile colspan="2">
      <form class="example-form">
        <mat-form-field appearance="standard" class="example-full-width">
          <mat-label>{{'selectSubCategory' | translate}}</mat-label>
          <input type="text" matInput [formControl]="searchSubCategory" required [matAutocomplete]="auto1"
            autocomplete="off">
          <button mat-button matSuffix mat-icon-button>
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
          <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="selectSubCatChange($event.option.value)"
            [displayWith]="displayFnSubCategory">
            <mat-option *ngFor="let option of filteredOptionsSubCategory | async" [value]="option">
              <img class="example-option-img" aria-hidden [src]="imagPath + option.imgUrl" height="25" width="25"
                style="object-fit: fill;">
              <span>&nbsp;</span>
              <span>{{language == 1 ? option.arabicName : option.englishName}}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form>
    </mat-grid-tile>

    <mat-grid-tile colspan="1">
      <mat-form-field appearance="standard">
        <mat-label>{{'subCategoryStatus' | translate}}</mat-label>
        <mat-select [(value)]="selectedStatus" (selectionChange)="selectStatusChange()"
          [disabled]="selectedSubCategory == null">
          <mat-option *ngFor="let status of productStatus" [value]="status.id">
            {{status.name | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      <mat-form-field appearance="standard">
        <mat-label>{{'filter' | translate}}</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input
          [disabled]="selectedSubCategory == null">
      </mat-form-field>
    </mat-grid-tile>

  </mat-grid-list>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'id' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.id}} </td>
      </ng-container>

      <!-- Progress Column -->
      <ng-container matColumnDef="arabicName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'arabicName' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.arabicName}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="englishName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'englishName' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.englishName}} </td>
      </ng-container>

      <ng-container matColumnDef="cardCounts">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'cardCounts' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="getProductCardsCount(row,-1)" *ngIf="row.cardCounts == 0">
            <mat-icon>search</mat-icon>
          </button>
          <span *ngIf="row.cardCounts != 0">{{row.cardCounts}}</span>
          <!-- {{row.cardCounts}} -->
        </td>
      </ng-container>

      <ng-container matColumnDef="cardSoldCounts">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'cardSoldCounts' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="getProductCardsCount(row,1)" *ngIf="row.cardSoldCounts == 0">
            <mat-icon>search</mat-icon>
          </button>
          <span *ngIf="row.cardSoldCounts != 0">
            {{row.cardSoldCounts}}</span>
          <!-- {{row.cardSoldCounts}} -->
        </td>
      </ng-container>

      <ng-container matColumnDef="cardNotSoldCounts">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'cardNotSoldCounts' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.cardNotSoldCounts}} </td>
      </ng-container>

      <ng-container matColumnDef="availableCost">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'availableCost' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.availableCost}} </td>
      </ng-container>

      <!-- Color Column -->
      <ng-container matColumnDef="imageUrl">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'image' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <img src="{{imagPath + row.imageUrl}}" alt="no image" width="80">
        </td>
      </ng-container>

      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef> {{'edit' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="edit(row.id)">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef> {{'delete' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="onDelete(row.id)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}} "{{input.value}}"</td>
      </tr>
    </table>

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>

</div>

<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>

<ng-template #Modal>

  <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
  <div mat-dialog-content>
    <p>{{'areYouSureToDelete' | translate}}</p>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
    <button mat-button cdkFocusInitial (click)="confirmDelete()">{{'yes' | translate}}</button>
  </div>

</ng-template>